import { render, staticRenderFns } from "./TermForm.vue?vue&type=template&id=b7ac8b56"
import script from "./TermForm.vue?vue&type=script&lang=js"
export * from "./TermForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports